import React from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';
import logo from '../../images/logo.png';
import { NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
const Header = () => {
    return (
        <Navbar className="pt-3" expand="lg">
            <Container>
                <Navbar.Brand href="/home">
                    <img
                        src={logo}
                        width="100"
                        className="d-inline-block align-top"
                        alt="React Bootstrap logo"
                    />
                </Navbar.Brand>
                <Navbar.Toggle className="bg-white" aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto d-flex align-items-center">
                        <NavLink className="text-decoration-none ms-lg-2 me-lg-3 " exact to="/home"
                            style={{ color: 'white' }}
                            activeStyle={{
                                fontWeight: "bold",
                                color: "#BCEF7C"
                            }}>Home</NavLink>
                        <HashLink className="text-decoration-none ms-lg-2 me-lg-3" to="/#projects"
                            style={{ color: 'white' }}
                            activeStyle={{
                                fontWeight: "bold",
                                color: "#BCEF7C"
                            }}>Projects</HashLink>
                        <HashLink className="text-decoration-none ms-lg-2 me-lg-3" exact to="/#about"
                            style={{ color: 'white' }}
                            activeStyle={{
                                fontWeight: "bold",
                                color: "#BCEF7C"
                            }}>About</HashLink>
                        <NavLink className="text-decoration-none ms-lg-2 me-lg-3" exact to="/blogs"
                            style={{ color: 'white' }}
                            activeStyle={{
                                fontWeight: "bold",
                                color: "#BCEF7C"
                            }}>Blogs</NavLink>
                        <NavLink className="text-decoration-none ms-lg-2 me-lg-3" exact to="/contact"
                            style={{ color: 'white' }}
                            activeStyle={{
                                fontWeight: "bold",
                                color: "#BCEF7C"
                            }}>Contact</NavLink>

                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;